import { toast } from 'sonner';
import { Alert } from '@mui/material';
import React, { useState } from 'react';

import type { FileUploadType } from '../../features/file-upload';
import { DocumentListItem } from './components';
import { downloadFileWithToast } from './utils';
import { useGetDocument } from './useGetDocument.ts';
import type { DocumentFromStorage } from './DocumentManager.types.ts';
import { DocumentPreviewModal } from './DocumentPreviewModal.tsx';

type SingleDocumentListItemProps = {
  documentId: string;
  patientId: string;
  type: FileUploadType;
};

export const SingleDocumentListItem: React.FC<SingleDocumentListItemProps> = ({ documentId, patientId, type }) => {
  const { document, isLoading, isError } = useGetDocument({ documentId, patientId, type });
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewDocument, setPreviewDocument] = useState<DocumentFromStorage | null>(null);

  const handleOnDocumentDownload = async () => {
    if (!document) {
      toast.warning('Document not found');

      return;
    }

    downloadFileWithToast(document);
  };

  const handleOnPreview = (document: DocumentFromStorage) => {
    setPreviewDocument(document);
    setIsPreviewOpen(true);
  };

  const handlePreviewOnClose = () => {
    setIsPreviewOpen(false);
    setPreviewDocument(null);
  };

  if (isError) {
    return <Alert severity="error">Error loading document</Alert>;
  }

  return (
    <>
      <DocumentListItem
        isLoading={isLoading}
        document={document}
        onDocumentDownload={handleOnDocumentDownload}
        onPreview={handleOnPreview}
      />

      <DocumentPreviewModal
        open={isPreviewOpen}
        onClosePreview={handlePreviewOnClose}
        document={previewDocument}
        onDocumentDownload={handleOnDocumentDownload}
      />
    </>
  );
};
